module.exports = __webpack_public_path__ + "static/media/profile.7c12a2fb.svg";